var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfB({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      fill: "white",
      color: "currentcolor",
      width: 18,
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.927 0.197l10.272 6.758c0.681 0.448 0.687 1.445 0.012 1.902l-9.783 6.608v3.084c1.45-0.172 2.985-0.262 4.571-0.262 0.969 0 1.919 0.034 2.842 0.099 0.775-1.421 2.283-2.385 4.015-2.385 2.411 0 4.385 1.866 4.559 4.232 2.831 1.201 4.584 2.896 4.584 4.911 0 4.085-7.207 6.857-16 6.857s-16-2.772-16-6.857c0-2.947 3.751-5.211 9.143-6.243v-17.757c0-0.631 0.512-1.143 1.143-1.143 0.238 0 0.459 0.073 0.642 0.197zM11.429 3.263v9.443l7.083-4.784-7.082-4.659zM26.989 22.53c-0.733 1.545-2.308 2.613-4.132 2.613-2.501 0-4.533-2.008-4.571-4.5-0.743-0.047-1.507-0.071-2.286-0.071-1.606 0-3.144 0.104-4.571 0.289v3.139c0 0.631-0.512 1.143-1.143 1.143s-1.143-0.512-1.143-1.143v-2.756c-4.11 0.856-6.857 2.404-6.857 3.899 0 2.227 6.097 4.571 13.714 4.571s13.714-2.345 13.714-4.571c0-0.907-1.011-1.833-2.725-2.613z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfB);
export default __webpack_public_path__ + "static/media/golfB.130fc39e9fc2b0130b67f6d2b3fc49a5.svg";
export { ForwardRef as ReactComponent };